<template v-if="data">
  <nav class="footer-navigation">
    <ul v-for="{ children } in data">
      <li v-for="{ page } in filteredChildren(children)">
        <nuxt-link class="block p-3 text-neutral font-bold" :to="`${page.url}`"> {{ page.title }}</nuxt-link></li>
    </ul>
  </nav>
</template>

<style scoped>
</style>
<script setup lang="ts">
const { fetchFooterNavigation, data } = useFooterNavigation("footer_navigation");
await fetchFooterNavigation("footer_navigation");
const { loggedIn } = useUserSession();
const NuxtLink = resolveComponent('NuxtLink');

const filteredChildren = (children) => {
  if (!children) return [];

  return children.filter(child => {
    // Filter out find-a-dealer if user is logged in
    if (loggedIn.value) {
      if(child.page.url === 'find-a-dealer') {
        return false;
      }
    }
    return true;
  });
};
</script>
